import type { AnomalySeries } from 'commons';

export type SeriesInside = [Date | number | string, number | null, string | Partial<AnomalySeries> | null | undefined];

export type SeriesD = SeriesInside[];

export const TRANSLUSCENT_GREEN = 'rgba(0, 137, 61, 0.82)';
export const COMMENTARRY_BLUE = '#1C98B5';

export class ChartConstants {
  public static readonly DECIMAL_PLACE = 4;
}
